import { deleteDosageThunk, getDosagesThunk } from '@redux/features/dosage.slice';
import { AnimatedListSkeleton, AnimatedTable, AnimatedTableBody, AnimatedTableRow } from 'components/animations';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import BreadCrumb from 'Common/BreadCrumb';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import React, { FC, useEffect, useState } from 'react';
import AddDosageModal from './AddDosageModal';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import UpdateDosageModal from './UpdateDosageModal';

const Dosage: FC = () => {
    const [page, setPage] = useState<string>(`0`);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showAddDosageModal, setShowAddDosageModal] = useState<boolean>(false);
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [dosageId, setDosageId] = useState<number>();

    // -------------------------------------------------------------
    const dispatch = useAppDispatch();
    // -------------------------------------------------------------
    const { dosages, loading } = useAppSelector((state: RootState) => state.dosageState);
    // -------------------------------------------------------------
    const changePage = (page: string) => {
        setPage(page);
    };
    // -------------------------------------------------------------
    useEffect(() => {
        dispatch(getDosagesThunk());
    }, [page]);
    // -----------------------------------------------------
    console.log(dosages);
    // -----------------------------------------------------

    const handleConfirmDelete = async () => {
        if (dosageId) {
            dispatch(deleteDosageThunk(dosageId)).then((response: any) => {
                if (response.meta.requestStatus === 'fulfilled') {
                    setShowDeleteModal(false);
                    setDosageId(undefined);
                    dispatch(getDosagesThunk());
                }
            });
        }
    };

    const handleDeleteDosage = (id: number) => {
        setDosageId(id);
        setShowDeleteModal(true);
    };
    const handleUpdateDosage = (id: number) => {
        setDosageId(id);
        setShowUpdateModal(true);
    };
    // -----------------------------------------------------

    return (
        <>
            <UpdateDosageModal
                show={showUpdateModal}
                handleClose={() => setShowUpdateModal(false)}
                dosageId={dosageId || 0}
            />
            <AddDosageModal handleClose={() => setShowAddDosageModal(false)} show={showAddDosageModal} />
            <ConfirmationModal
                show={showDeleteModal}
                handleClose={() => {
                    setShowDeleteModal(false);
                    setDosageId(undefined);
                }}
                onConfirm={handleConfirmDelete}
                title="Delete Dosage"
                message="Are you sure you want to delete this dosage? This action cannot be undone."
                confirmButtonText="Delete"
                cancelButtonText="Cancel"
                id={dosageId}
            />
            <BreadCrumb pageTitle={`Dosage Form List`} />
            <section className="py-5">
                <div className=" p-3 flex flex-col gap-2 bg-[#fff]">
                    <div className="flex w-full items-center justify-between">
                        <h3 className="font-extrabold text-[#bd902e]">Dosages Form List</h3>
                        {/* <ButtonBase innerText="Add Dosage" onClick={() => setShowAddDosageModal(true)} /> */}
                    </div>
                    {loading ? (
                        <AnimatedListSkeleton rows={8} />
                    ) : (
                        <>
                            <div>
                                <div className="overflow-x-auto">
                                    <AnimatedTable className="table-custom w-full border-separate border-spacing-y-1 whitespace-nowrap">
                                        <thead className="ltr:text-left rtl:text-right">
                                            <tr
                                                className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                    after:left-0 after:top-0 after:border-l-2
                    after:border-transparent [&.active]:after:border-custom-500"
                                            >
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">ID</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">Dosage Name</th>
                                                {/* <th className="px-3.5 py-2.5 font-semibold uppercase text-center">
                                                    Actions
                                                </th> */}
                                            </tr>
                                        </thead>
                                        <AnimatedTableBody loading={loading} itemCount={dosages?.length ?? 0} animationKey={`dosage-${page}`}>
                                            {dosages?.map((dosage: any) => (
                                                <AnimatedTableRow
                                                    rowKey={dosage?.id}
                                                    detailRecord={dosage}
                                                    className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                        after:left-0 after:top-0 after:border-l-2 hover:bg-[#bd902e10]
                        after:border-transparent [&.active]:after:border-custom-500"
                                                >
                                                    <td className="px-3.5 py-2.5">{dosage?.id || `-`}</td>
                                                    <td className="px-3.5 py-2.5">{dosage?.dosageName || `-`}</td>
                                                    {/* <td className="px-3.5 py-2.5">
                                                        <div className="flex flex-row justify-center items-center gap-2 w-full">
                                                            <button
                                                                className="group flex px-4 py-2 text-xs font-semibold items-center justify-center
                                                        rounded-md border border-red-500 text-red-600
                                                        bg-white transition-all duration-300 ease-linear hover:bg-red-50 hover:border-red-600 hover:scale-105 active:scale-95"
                                                                onClick={() => {
                                                                    handleDeleteDosage(dosage?.id);
                                                                }}
                                                            >
                                                                Delete
                                                            </button>
                                                            <button
                                                                className="group flex px-4 py-2 text-xs font-semibold items-center justify-center
                                                        rounded-md border border-yellow-600 text-yellow-600
                                                        bg-white transition-all duration-300 ease-linear hover:bg-yellow-50 hover:border-yellow-700 hover:scale-105 active:scale-95"
                                                                onClick={() => {
                                                                    handleUpdateDosage(dosage?.id);
                                                                }}
                                                            >
                                                                Update
                                                            </button>
                                                        </div>
                                                    </td> */}
                                                </AnimatedTableRow>
                                            ))}
                                        </AnimatedTableBody>
                                    </AnimatedTable>
                                </div>
                                {/* <Pagination
                                    perPageData={dosages?.totalElements}
                                    total={dosages?.totalPages}
                                    currentPage={page as unknown as number}
                                    changePage={changePage}
                                    length={dosages?.totalElements}
                                /> */}
                            </div>
                        </>
                    )}
                </div>
            </section>
        </>
    );
};

export default Dosage;
